// src/utils/roleIcons.js
// Central role-to-icon registry. Values are Lucide icon keys, not emoji.

const roleIcons = {
  // CIS / technology
  "SO2 CYBER": "monitor",
  "SO2 IT": "monitor",
  "SO2 COMMS": "radio",
  "SO1 COMMS": "radio",
  "SO1 IT": "monitor",
  "COL CIS": "radio",
  "SI Comms": "radio",
  "SI IT": "monitor",
  "SI Tech": "wrench",
  "ICT Officer": "monitor",
  "ICT Instructor": "monitor",
  "ICT Technician": "wrench",
  "System Manager": "monitor",
  "Deputy System Manager": "monitor",
  "Computer Technician": "wrench",
  "Tech Specialist": "wrench",
  "Computer System Expert": "monitor",
  "Database Admin": "database",
  "Network Admin": "radio",
  "Network Specialist": "radio",
  "Web Designer": "monitor",
  "AV Technician": "monitor",
  Projectionist: "monitor",

  // SYS / equipment
  "COL SYS": "settings",
  "SO1 PSO/COE": "map",
  "SO2 EQPT/VEH SYS": "truck",
  "SO2 AMMO/WPN SYS": "settings",
  "S02 SYS": "settings",
  "IC TACWPN": "settings",
  "Weapons Instructor": "target",

  // OOTW / field
  "COL OOTW": "map",
  "SO1 OOTW": "map",
  "S02 OOTW": "map",
  "S02 PSO/COE": "map",
  "SO2 ENVIROMENTAL": "map",
  "SO2 CBT ENGR/CIMIC": "wrench",

  // OPS
  COOPS: "target",
  "COL OPS": "target",
  "SO1 OPS": "target",
  S01PLANS: "target",
  "SO2 OPS": "target",
  GLO: "map",
  "SO2 W/KEEPER": "settings",
  "S02 OPS & LOGS": "truck",
  "SO2 PLANS": "target",
  "MASTER CHIEF": "users",

  // Command
  "COMD ASOB": "crown",
  "Deputy COMD": "medal",
  COMD: "crown",
  Commandant: "crown",
  Commander: "crown",
  "Commanding Officer": "shield",
  "Officer Commanding": "shield",
  CO: "shield",
  "CO 20": "shield",
  "CO 40": "shield",
  "CO 60": "shield",
  OC: "shield",
  "OC OCS": "shield",
  "OC Demo Coy": "shield",
  "BN 2IC": "medal",
  "2IC OCS": "medal",
  "2IC Demo Coy": "medal",

  // Staff / admin
  "SO2 Ops & Trg": "target",
  "SO3 Ops & Trg": "target",
  "SO2 Pers & Log": "clipboard",
  "SO3 Pers & Log": "clipboard",
  "SO2 Cbt Int": "compass",
  MCC: "clipboard",
  Clerk: "fileSearch",
  Adjutant: "clipboard",
  "Admin Officer": "clipboard",
  "Admin Wing": "clipboard",
  "IC Admin": "clipboard",
  "SO3 GSO": "clipboard",
  "Clerk GD": "fileSearch",
  "Typist & Support Staff": "keyboard",

  // Clerk network
  "Chief Clerk": "fileSearch",
  "Dorcus Clerk": "inbox",
  "Dispatch Clerk": "send",
  Comcen: "radio",
  "Registry Clerk": "fileSearch",
  "Training Clerk": "bookOpen",
  "Master Clerk": "fileSearch",
  "Typing Clerk": "keyboard",

  // Training / education
  "Chief Instructor": "graduationCap",
  "Senior Instructor": "bookOpen",
  "Training Officer": "graduationCap",
  "PT Instructor": "graduationCap",
  "Combat Skills Instructor": "target",
  "Combative Instructor": "target",
  "Live Guard Instructor": "shield",
  "Communications Instructor": "radio",
  "Drill Instructor": "graduationCap",
  Instructor: "graduationCap",
  "DEAN FAS": "graduationCap",
  "Senior Lecturer": "graduationCap",
  "SO3 Academics": "bookOpen",
  Lecturer: "bookOpen",
  "Tutorial Fellow": "bookOpen",
  "Education Instructor": "graduationCap",
  "Assistant Librarian Instructor": "bookOpen",

  // Specialist / support
  BSO: "fileText",
  MA: "user",
  DAC: "bookOpen",
  YOS: "bookOpen",
  FOS: "bookOpen",
  SO2: "target",
  "CHIEF OF BRANCH": "landmark",
  "Platoon Commander": "shield",
  "IC Training & Support": "clipboard",
  "2IC Training & Support": "clipboard",
  "Support Officer": "briefcase",
  "IC PT & CBT Training": "graduationCap",
  "2IC PT & CBT Training": "graduationCap",
  "GSO 3rd Year": "graduationCap",
  "GSO 2nd Year": "bookOpen",
  "GSO 1st Year": "bookOpen",
  "GSO Graduate": "medal",
  "Specialist Officer": "briefcase",
  SDO: "shield",

  // FAS / library / labs
  "GIS Officer": "map",
  "MET Officer": "map",
  "Biology Lab Technician": "wrench",
  "SO3 Labs": "wrench",
  "IC Labs": "wrench",
  "2IC Labs": "wrench",
  "Lab Assistant": "wrench",
  "Lab Technician": "wrench",
  "Lab Technician Instructor": "wrench",
  "MET Technician": "map",
  "GIS Technician": "map",
  "Chief Librarian": "bookOpen",
  "Assistant Librarian": "bookOpen",
  "Library Assistant": "bookOpen",
  "Library Assistant (Archives)": "archive",
  "Support Staff": "briefcase",
  Curator: "archive",
  "Library Assistant (Skill/Edn Instructor)": "bookOpen",
  Archivist: "archive",
  QMS: "barChart",
  "Tech Lab": "wrench",
  "Maintenance Technician": "wrench",
  "Hardware/Software Technician": "wrench",
  "Office Maintenance Technician": "wrench",
};

const iconLabels = {
  archive: "Archive",
  barChart: "Dashboard analytics",
  bookOpen: "Education",
  briefcase: "Officer",
  clipboard: "Administration",
  compass: "Intelligence",
  crown: "Command",
  database: "Database",
  fileSearch: "Registry",
  fileText: "File desk",
  graduationCap: "Training",
  inbox: "Inbox clerk",
  keyboard: "Typing desk",
  landmark: "Headquarters",
  map: "Field operations",
  medal: "Deputy command",
  monitor: "Technology",
  radio: "Communications",
  send: "Dispatch",
  settings: "Systems",
  shield: "Unit command",
  target: "Operations",
  truck: "Logistics",
  user: "User role",
  users: "Supervision",
  wrench: "Technical support",
};

const normalizeRole = (roleName) =>
  String(roleName || "")
    .trim()
    .toUpperCase()
    .replace(/\s+/g, " ");

const normalizedRoleIcons = Object.fromEntries(
  Object.entries(roleIcons).map(([roleName, iconKey]) => [normalizeRole(roleName), iconKey])
);

export const getRoleIconKey = (roleName) => {
  const normalized = normalizeRole(roleName);
  const exact = normalizedRoleIcons[normalized];
  if (exact) return exact;

  if (normalized.includes("COMMANDANT") || normalized.includes("COMMANDER") || normalized.includes("COMD")) return "crown";
  if (normalized === "CO" || normalized.includes("COMMANDING OFFICER") || normalized.includes("OC")) return "shield";
  if (normalized.includes("2IC") || normalized.includes("DEPUTY")) return "medal";
  if (normalized.includes("OPS") || normalized.includes("OPSO") || normalized.includes("PLANS")) return "target";
  if (normalized.includes("INT")) return "compass";
  if (normalized.includes("CYBER") || normalized.includes("IT") || normalized.includes("ICT") || normalized.includes("SYSTEM")) return "monitor";
  if (normalized.includes("DATABASE")) return "database";
  if (normalized.includes("COMM") || normalized.includes("COMMS") || normalized.includes("RADIO") || normalized.includes("SIGNAL")) return "radio";
  if (normalized.includes("LOG") || normalized.includes("TPT") || normalized.includes("TRANSPORT")) return "truck";
  if (normalized.includes("ADMIN") || normalized.includes("PERS") || normalized.includes("ADJUTANT")) return "clipboard";
  if (normalized.includes("CLERK") || normalized.includes("REGISTRY") || normalized.includes("TYPING") || normalized.includes("COMCEN")) return "fileSearch";
  if (normalized.includes("INSTRUCTOR") || normalized.includes("LECTURER") || normalized.includes("DEAN") || normalized.includes("GSO")) return "graduationCap";
  if (normalized.includes("LIBRARY") || normalized.includes("LIBRARIAN") || normalized.includes("EDUCATION")) return "bookOpen";
  if (normalized.includes("MAINTENANCE") || normalized.includes("TECH") || normalized.includes("WORKSHOP") || normalized.includes("WKSP")) return "wrench";
  if (normalized.includes("WEAPON") || normalized.includes("WPN") || normalized.includes("AMMO")) return "settings";
  if (normalized.includes("GIS") || normalized.includes("MET") || normalized.includes("ENVIRONMENT")) return "map";
  if (normalized.includes("BRANCH") || normalized.includes("HQ")) return "landmark";
  if (normalized.includes("MASTER") || normalized.includes("CHIEF")) return "users";
  if (normalized.includes("OFFICER") || normalized.includes("SPECIALIST")) return "briefcase";

  return "user";
};

export const getRoleIconMeta = (roleName) => {
  const key = getRoleIconKey(roleName);
  return {
    key,
    label: iconLabels[key] || "User role",
  };
};

export default roleIcons;
